import ComingSoonPage from '../../ui-components/ComingSoonPage';

const HBTemplatesPage = () => {
  return <ComingSoonPage title="HB Templates" />;
};

export default HBTemplatesPage;
